import { Countries } from "./Types";

export const getCountry = (): Countries => {
	const regex = /\.ca$/i;
	const isCanadaUrl = regex.test(window.location.hostname);
	return isCanadaUrl ? "CA" : "US";
};
